import { IMenuItem } from 'models/IMenuItem';
import cn from 'classnames';
import styles from './styles.scss';
import { stopPropagation } from 'components/Shared/Button';
import { IconArrow } from 'components/Shared/Icon';

interface OwnProps {
  subCategories: IMenuItem[];
  allCategories?: boolean;
  className?: string;
}

export const SubCategories = ({ subCategories, allCategories, className }: OwnProps) => (
  <ul className={cn(styles.subCategories, className)}>
    {subCategories.map(category => (
      <li key={category.title}>
        <a
          href={category.url}
          onClick={stopPropagation}
          className={cn(styles.subCategory, { [styles.allCategories]: allCategories })}
        >
          {category.title}
        </a>
        {allCategories && (
          <ul className={styles.allCategories}>
            {category.subCategories.map(subCategory => (
              <li key={subCategory.id}>
                <a href={subCategory.url}>{subCategory.title}</a>
              </li>
            ))}
            {category.subCategoriesCount &&
              category.subCategoriesCount > category.subCategories.length && (
                <li className={styles.seeAllCategories}>
                  <a href={category.url}>
                    Se alla {category.subCategoriesCount}
                    <IconArrow size="small" />
                  </a>
                </li>
              )}
          </ul>
        )}
      </li>
    ))}
  </ul>
);
